//overview: '/overview',
const SLUGS=  {
    // private
    dashboard: '/dashboard',

    articulos: '/articulos',
    diferencia: '/articulos/diferencia',
    diferencias: '/articulos/diferencias',
    publicadormasivo: '/publicador-masivo',
    asignacionautomatica: '/asignacion-automatica',
    
    // auth
    login: '/login',
    signup: '/signup',
    register: '/register',
    activation: '/activation/:token',

    forgotPassword: '/forgotpassword',
    resetpassword: '/resetpassword/:token',
    //home
    clientes: '/clientes',

    Cobrador: '/cobrador',
    Vendedor: '/Vendedor',

    //procesos
    //procesos: '',
    mensajes: '/mensajes',
    tiposMensajes: '/tiposmensajes',
    respuestasMensajes: '/RespuestasMensajes',

    historialexistenciaentrada: '/historialexistenciaentrada',
    historialexistenciasalida: '/historialexistenciasalida',

    ventas: '/ventas',
    sucursal: '/conexion',
    impuestos: '/impuestos',
    facturas: '/facturas',
    facturasRecibidas: '/FacturasRecibidas',
    usuarios: '/usuarios',
    empresa: '/empresa',
    empresas: '/empresas',
    sucursales: '/conexion',
    sellosfiscales: '/sellosfiscales',
    //tienda: '/tienda',
    camposempresa: '/camposempresa',
    paquetes: '/paquetes',
    carrito: '/carrito',
    planesyprecios: '/PlanesYPrecios',
    facturar: '/facturar/:id',
    // facturar: '/facturar',
    movimientos: '/movimientos',
    movimientosinventarioe: '/movimientosinventarioe',
    movimientosinventarios: '/movimientosinventarios',
    bolsatimbres: '/bolsatimbres',
    FacturacionGlobal: '/FacturacionGlobal',
    descargasat: '/descargasat',
    ayuda: '/ayuda',
    soporte: '/Soporte',
    miperfil: '/MiPerfil',

    EshopConfig: '/EshopConfig',

    pagomercadopago: 'PagoMercadoPago',

    mercadolibre: '/MercadoLibre',
    tiendanube: '/TiendaNube',

    categorias: '/categorias',
    etiquetas: '/etiquetas',
    atributos: '/atributos',
    almacenes: '/almacenes',

    facturacion: '/facturacion/:empresa',
    lognotificaciones: '/lognotificaciones',

    rolesclaves: '/rolesclaves',
    rolespermisos: '/rolespermisos',

    //documentos
    documentos: '/documentos',
    cotizaciones: '/documentos/cotizaciones',
    pedidos: '/documentos/pedidos',
    remisiones: '/documentos/remisiones',

    listaprecios: '/listaPrecios',

    compras: '/compras',
    ordencompra: '/compras/ordenesCompras',
    comprasList: '/compras/compras',
    recepcioncompra: '/compras/recepcionCompra',

    vxgruporutas: '/gruporutas',
    vxrutas: '/rutas',
    vxCobros: '/clientescreditos',
    vxCreditos: '/vxcreditos',
    vxcreditosProveedores: '/proveedorescargos',
    vxCompras: '/compras',
    vxCargos: '/proveedorescreditos',

    proveedores: '/proveedores',
    condicionpago: '/CondicionPago',
    
    vxmovimientos: '/vxmovimientos',
    vxpedidos: '/vxpedidos',
    vxventas: '/vxventas',
    vxfacturas: '/vxfacturas',
    vxsaldosproveedores: '/vxsaldosproveedores',
    vxotrosdocumentos: '/vxotrosdocumentos',
    vxplanvisita: '/vxplanvisita',
    vxvisitas: '/vxvisitas',
    vxrazonvisitas: '/vxrazonvisitas',
    vxagentes: '/vxagentes',
    vxentregas: '/vxentregas',
    creditocliente: '/clientescargos',
    vxcuentasbancos: '/vxcuentasbancos',
    vxformascobroscc: '/vxformascobroscc',
    pvformascobro: '/pv/formas-cobro',
    pvcajeros: '/pv/cajeros',
    pvcajas: '/pv/cajas',
    pvmovimientos: '/pv/movimientos',
    pvcortes: '/pv/cortes',
    pvdocumentos: '/pv/documentos',
    listaSMS: '/listaSMS',
    vxrecorrido: '/vxrecorrido',
    vxubicacion: '/vxubicacion',
    

    altiria: '/altiria',
    smscobranza: '/smscobranza',
    ConfigAppMaxventas: '/ConfigAppMaxventas',


    //enddocumentos
    pagos: '/pagos',
    // Estadisticas
    est_ingresos_diarios: '/estadisticas/ingresos-diarios',
    est_ingresos_mensuales: '/estadisticas/ingresos-mensuales',
    est_egresos_mensuales: '/estadisticas/egresos-mensuales',
    est_ingresos_vs_egresos_mensuales: '/estadisticas/ingresos-vs-egresos-mensuales',
    est_top_clientes: '/estadisticas/top-clientes',
    est_top_proveedores: '/estadisticas/top-proveedores',
    file: '/file',

    //documentacion legal
    avisoprivacidad: '/AvisoPrivacidad',
    terminoscondiciones: '/TerminosCondiciones',
    seriesEmpresa: '/SeriesEmpresa/edit/:id',
    home: '/'
    
    
};

export default SLUGS;
